module.exports = "/static/assets/728ba051b0ac7b16e0aa4a320f70f506.png";